import { render } from "./section-four.vue?vue&type=template&id=374f7500&scoped=true"
const script = {}

import "./section-four.vue?vue&type=style&index=0&id=374f7500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374f7500"]])

export default __exports__